import React from 'react';
import styles from './Recommendation.module.css';
import Button from '../UI/Button';

const routeChange=(up)=> {
     window.open("https://api.whatsapp.com/send?phone=&text=Halo%2C%20saya%20sudah%20coba%20kalkulator%20di%20Grow%20Idea.%0A%0ANama%3A%0AHasil%20kebutuhan%3A%20Rp%20"+up+"%0A%0ASaya%20ingin%20tahu%20rekomendasinya.", '_blank');
  }
const Recommendation = ({ produk, usia, up }) => {
  
  return (
    <div className={styles.recommendation}>
      <h3>💡 Rekomendasi Produk</h3>
      <div className={styles.content}>
        <p className={styles.produk}>{produk}</p>
        
        <div className={styles.tips}>
          <h4>Tips Memilih Asuransi Jiwa:</h4>
          <ul>
            <li>✅ Bandingkan premi dari 2-3 perusahaan asuransi</li>
            <li>✅ Baca polis dengan teliti (manfaat, pengecualian, masa tunggu)</li>
            <li>✅ Isi aplikasi dengan jujur (terutama riwayat kesehatan)</li>
            <li>✅ Pastikan pembayaran premi otomatis agar tidak lapse</li>
            <li>✅ Informasikan keluarga bahwa Anda memiliki asuransi jiwa</li>
          </ul>
        </div>

        <div className={styles.nextSteps}>
          <h4>Langkah Selanjutnya:</h4>
          <ol>
            <li>Konsultasi dengan perencana keuangan untuk validasi</li>
            <li>Minta ilustrasi dari beberapa perusahaan asuransi</li>
            <li>Pilih produk yang sesuai dengan kebutuhan dan budget</li>
            <li>Lakukan medical check-up jika diperlukan</li>
            <li>Review polis setiap 2-3 tahun atau saat ada perubahan besar</li>
          </ol>
          <div className={styles.buttons}>
            <Button variant="danger" onClick={()=>routeChange(up)}>
             💬 Konsultasi Gratis 30 Menit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recommendation;